
  var _styles = {
  "max-demo-title": {
    "fontFamily": "Arial",
    "fontSize": "0.6rem",
    "fontWeight": "bold",
    "padding": "0.53333rem",
    "display": "flex",
    "backgroundColor": "rgb(10,29,86)",
    "color": "rgb(253,231,103)"
  },
  "city-drop-down-card": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  }
};



  module.exports = _styles;
  